import * as React from 'react';
import { Container, Grid2, IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../setup/Navbar';
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal';
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination';
import Loading from '../../../BuiltInComponent/Loading';
import { getPIData, getPIMasterData } from '../../../features/StockManagement/Purchases/piSlice';
import { printPurchaseInvoice } from '../../../utils/purchaseInvoicePrint';
import { exportPurchaseDocumentExcel, exportPurchaseDocumentPDF } from '../../../utils/purchaseDocumentExport';
import AssessmentIcon from '@mui/icons-material/Assessment';

export default function PurchaseInvoiceList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { masterData, isLoading } = useSelector((state) => state.pi);
    const { user } = useSelector((state) => state.auth);

    React.useEffect(() => { dispatch(getPIMasterData()); }, [dispatch]);

    const columns = [
        { fieldName: 'piID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Post Date', textAlign: 'left', width: 100, status: 'en', dType: 'date' },
        { fieldName: 'dispName', cName: 'Created By', textAlign: 'left', width: 120, status: 'en', dType: 'string' },
        { fieldName: 'PartyName', cName: 'Supplier', textAlign: 'left', width: 160, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 180, status: 'en', dType: 'string' },
        { fieldName: 'piStatus', cName: 'Status', textAlign: 'left', width: 90, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Items', textAlign: 'right', width: 70, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 70, status: 'en', dType: 'string', action: true },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 70, status: 'dis', dType: 'string', action: true },
        { fieldName: 'Print', cName: 'Print', textAlign: 'center', width: 70, status: 'en', dType: 'string', icon: 'print', action: true },
        { fieldName: 'Excel', cName: 'Excel', textAlign: 'center', width: 80, status: 'en', icon: 'excel', action: true },
        { fieldName: 'PDF', cName: 'PDF', textAlign: 'center', width: 70, status: 'en', icon: 'pdf', action: true },
    ];

    const handlePrint = async (piID) => {
        const printWindow = window.open('', '_blank', 'width=1000,height=800');
        if (!printWindow) return alert('Please allow pop-ups to print the invoice.');
        printWindow.document.write('<p style="font-family:Arial;padding:24px">Preparing purchase invoice...</p>');
        try {
            const data = await dispatch(getPIData(piID)).unwrap();
            const listRow = (masterData || []).find((row) => Number(row.piID) === Number(piID));
            printPurchaseInvoice(printWindow, data?.pm?.[0], data?.pi || [], listRow, user);
        } catch (error) {
            printWindow.close();
            alert(`Purchase Invoice print failed: ${error}`);
        }
    };
    const exportDocument = async (piID, exporter) => {
        try {
            const data = await dispatch(getPIData(piID)).unwrap();
            const listRow = (masterData || []).find((row) => Number(row.piID) === Number(piID));
            exporter({ type: 'PI', master: data?.pm?.[0], details: data?.pi || [], listRow });
        } catch (error) {
            alert(`Purchase Invoice export failed: ${error}`);
        }
    };
    return <><Navbar /><Container>
        <Grid2 container spacing={2} sx={{ mt: 2, mb: 2 }}><Grid2 size={{ xs: 12, md: 7 }} />
        <Grid2 size={{ xs: 12, sm: 10, md: 4 }}>
            <ButtonNormal text='Add New Purchase Invoice' onClick={() => navigate('/AddPurchaseInvoice')} />
        </Grid2><Grid2 size={{ xs: 12, sm: 2, md: 1 }} sx={{ textAlign: 'right' }}>
            <Tooltip title='Current Stock Report'>
                <IconButton color='primary' size='large' sx={{ p: 1.25 }} onClick={() => navigate('/CurrentStock')}>
                    <AssessmentIcon fontSize='large' />
                </IconButton>
            </Tooltip>
        </Grid2></Grid2>
        {isLoading ? <Loading /> : <StickyHeadTable tableColumns={columns} tableData={masterData || []}
            onEditClick={(piID) => navigate('/AddPurchaseInvoice', { state: { piID } })} onDeleteClick={() => {}} onButtonClick={handlePrint} onPrintClick={handlePrint}
            onExcelClick={(piID) => exportDocument(piID, exportPurchaseDocumentExcel)} onPdfClick={(piID) => exportDocument(piID, exportPurchaseDocumentPDF)} />}
    </Container></>;
}
